import { EngagementProductWithDeliveryInfoResponseDto } from '@epicuro-next/data/engagement/engagement-models';
import { mapProductDeliveryInfoTotals } from '@epicuro-next/features/engagement/list-utils';

export const mapListProductReferenceTotals = (
  productsReference: EngagementProductWithDeliveryInfoResponseDto[],
) =>
  productsReference.reduce(
    (totals, productReference) => {
      const { totalPrice, totalRequestedQuantity } =
        mapProductDeliveryInfoTotals(productReference.deliveryInfo);
      return {
        totalRequestedQuantity:
          totals.totalRequestedQuantity + totalRequestedQuantity,
        totalPrice: totals.totalPrice + totalPrice,
      };
    },
    {
      totalRequestedQuantity: 0,
      totalPrice: 0,
    },
  );
